module.exports = __webpack_public_path__ + "static/bc-sm-a2a06f31bbc9dc1e77dd427a896d6ca7.jpg";